// extracted by mini-css-extract-plugin
export default {"chip":"StudioWorkChip_chip__8TNu9","chipOpen":"StudioWorkChip_chipOpen__H6ruC","spin":"StudioWorkChip_spin__Y-Lho","bad":"StudioWorkChip_bad__YVtMw"};